import en from "./en";
// import zhCn from "./zh-cn";
import GB_en from "./en-gb";
// import FI_fi from "./fi/fi";
import { Translations, Countries } from "@whitehatgaming/shared/lib/translations";
import sv from "./sv";
import no from "./no";
import fr from "./fr";
import fi from "./fi";
import de from "./de";
import es from "./es";
import pt from "./pt";

export const countries: Countries = {
  'gb': {
     'en': GB_en
  }
}
export const translations: Translations = {
  'de': de,
  'en': en,
  'fi': fi,
  'fr': fr,
  'no': no,
  'sv': sv,
  'es': es,
  'pt': pt
  // 'zh-cn': zhCn
}
